import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
    const { pathname } = useLocation();

    useLayoutEffect(() => {
        if ('scrollRestoration' in window.history) {
            window.history.scrollRestoration = 'manual';
        }

        const previousScrollBehavior = document.documentElement.style.scrollBehavior;
        document.documentElement.style.scrollBehavior = 'auto';

        const resetScroll = () => {
            window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
            document.documentElement.scrollTop = 0;
            document.body.scrollTop = 0;
        };

        resetScroll();
        const followUp = window.setTimeout(() => {
            resetScroll();
            document.documentElement.style.scrollBehavior = previousScrollBehavior;
        }, 0);

        return () => {
            window.clearTimeout(followUp);
            document.documentElement.style.scrollBehavior = previousScrollBehavior;
        };
    }, [pathname]);

    return null;
};

export default ScrollToTop;
